import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";

// Define your routes here
const routes: Array<RouteRecordRaw> = [
  {
    name: "Home",
    path: "/home",
    meta: {
      title: "Home",
    },
    component: () => import("@/pages/views/Home.vue"), // Add this field
  },
  {
    name: "Dashboard",
    path: "/",
    meta: {
      title: "Dashboard",
    },
    component: () => import("@/pages/views/Dashboard.vue"), // Add this field
  },
];

// Create and export the router instance
export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes, // Corrected this line
});
